import { useState } from 'react';
import { Search, Bell, Mic } from 'lucide-react';

interface HeaderProps {
  title: string;
  subtitle?: string;
  onVoiceToggle?: () => void;
  voiceActive?: boolean;
}

export default function Header({ title, subtitle, onVoiceToggle, voiceActive }: HeaderProps) {
  const [search, setSearch] = useState('');

  return (
    <header className="flex items-center justify-between px-4 md:px-8 py-4 md:py-5"
      style={{ borderBottom: '1px solid var(--border-primary)' }}>

      <div className="min-w-0">
        <h2 className="font-display text-lg md:text-xl truncate" style={{ color: 'var(--text-primary)' }}>
          {title}
        </h2>
        {subtitle && (
          <p className="text-xs md:text-sm mt-0.5 truncate" style={{ color: 'var(--text-muted)' }}>
            {subtitle}
          </p>
        )}
      </div>

      <div className="flex items-center gap-2 md:gap-4">
        {/* Search: hidden on mobile to save space */}
        <div className="relative hidden md:block">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2"
            style={{ color: 'var(--text-muted)' }} />
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-10 pr-4 min-h-[48px] rounded-lg text-sm w-[260px] outline-none transition-all duration-200"
            style={{
              background: 'var(--bg-input)',
              border: '1px solid var(--border-primary)',
              color: 'var(--text-primary)',
            }}
            onFocus={(e) => e.currentTarget.style.borderColor = 'var(--netrun-green)'}
            onBlur={(e) => e.currentTarget.style.borderColor = 'var(--border-primary)'}
          />
        </div>

        {/* Voice toggle */}
        {onVoiceToggle && (
          <button
            onClick={onVoiceToggle}
            className="flex items-center justify-center rounded-full transition-all duration-200 cursor-pointer"
            style={{
              width: 'var(--touch-target-min)',
              height: 'var(--touch-target-min)',
              background: voiceActive ? 'var(--netrun-green)' : 'var(--bg-input)',
              color: voiceActive ? 'var(--netrun-black)' : 'var(--text-secondary)',
              border: `1px solid ${voiceActive ? 'var(--netrun-green)' : 'var(--border-subtle)'}`,
            }}
            title="Toggle Charlotte Voice"
          >
            <Mic size={20} />
          </button>
        )}

        {/* Notifications */}
        <button className="relative flex items-center justify-center rounded-full cursor-pointer"
          style={{
            width: 'var(--touch-target-min)',
            height: 'var(--touch-target-min)',
            background: 'var(--bg-input)',
            color: 'var(--text-secondary)',
            border: '1px solid var(--border-primary)',
          }}>
          <Bell size={20} />
        </button>
      </div>
    </header>
  );
}
